import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import {
    AppFeature,
    CampaignFeature,
    DealerFeature,
    RouterLinkDirective,
    TrackingDirective,
} from '@hyundai/ng-common-lib';
import {
    M010C010IconDoubleCtaComponent,
    M010C020IconLinkComponent,
    M040C020RteComponent,
    M040C020TeaserAllrounderComponent,
    M040C040ShopCardWrapperComponent,
    M040C080ImageTeaserComponent,
    M040C090IconTextCardComponent,
} from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { GlobalContactComponent } from '../../../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-campaign-detail-page-after-sale',
    standalone: true,
    templateUrl: './campaign-detail-page-after-sale.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLinkDirective,
        M010C010IconDoubleCtaComponent,
        M010C020IconLinkComponent,
        GlobalContactComponent,
        M040C020RteComponent,
        M040C020TeaserAllrounderComponent,
        M040C040ShopCardWrapperComponent,
        M040C080ImageTeaserComponent,
        M040C090IconTextCardComponent,
        TrackingDirective,
    ],
})
export class CampaignDetailPageAfterSaleComponent {
    activatedRoute = inject(ActivatedRoute);
    store = inject(Store);

    campaignDetail = this.store.selectSignal(CampaignFeature.state.selectLoadedCampaignDetail);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    dealerLocationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    showOnlyPrimaryButton = this.store.selectSignal(AppFeature.state.selectIsOpen);

    activeId = toSignal(
        this.activatedRoute.queryParams.pipe(
            map((activeParams) => {
                return activeParams['id'] as string;
            }),
        ),
    );

    activeUtmParam = toSignal(
        this.activatedRoute.queryParams.pipe(
            map((activeParams) => {
                return activeParams['utm_creative_format'] as string;
            }),
        ),
    );

    featuredElement = computed(() => {
        const { afterSalesContent } = this.campaignDetail();
        if (!afterSalesContent) return;

        const id = this.activeId();
        const utmParam = this.activeUtmParam();
        const serviceLinkLabel = 'Termin vereinbaren';

        if (id || utmParam) {
            const afterSaleItem = afterSalesContent.afterSalesServicesMapped.find(
                (item) =>
                    (id && item?.itemId?.toLocaleUpperCase() === id.toLocaleUpperCase()) ||
                    (utmParam && item?.serviceId?.toLocaleUpperCase() === utmParam.toLocaleUpperCase()),
            );
            if (afterSaleItem) {
                return {
                    ...afterSaleItem,
                    fragment: undefined,
                    linkText: serviceLinkLabel,
                };
            }

            const shopItem = afterSalesContent.afterSalesAccesoriesCards.find(
                (item) =>
                    (id && item?.itemId?.toLocaleUpperCase() === id.toLocaleUpperCase()) ||
                    (utmParam && item?.utmCreativeFormatParam?.toLocaleUpperCase() === utmParam.toLocaleUpperCase()),
            );
            if (shopItem) {
                return {
                    ...shopItem,
                    fragment: shopItem.linkFragment,
                    image: shopItem.highlightTeaserImage,
                    linkText: shopItem.linkFragment ? 'Angebot entdecken' : 'Jetzt anfragen',
                };
            }
        }

        return {
            ...afterSalesContent.afterSalesServicesMapped[0],
            fragment: undefined,
            linkText: serviceLinkLabel,
        };
    });
}
